import RegistrationTracker from '../RegistrationTracker';

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('#registration-learners-completed')) return;

  // tracking by EFO
  const tracker = new RegistrationTracker();
  tracker.track(4, { subset: 'cv_trial' });
});
